module.exports = __webpack_public_path__ + "img/oth2.19311e3f.png";